function oe_escape(string) {
	return string
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");
}

function init_oe_UTM(){
	
	const utm_params = ['utm_source', 'utm_medium', 'utm_campaign'];
	const search_params = new URLSearchParams(window.location.search);
	window.dataLayer = window.dataLayer || [];

	search_params.forEach((value, key) => {
		if(utm_params.includes(key)){

            let key_val = key.replace('_', '');

			sessionStorage.setItem( key_val, value );

			dataLayer.push({
				event: key,
				utm_param: {
					key: key,
					value: value,
				}
			});
		}
	});

	apply_oe_UTM();
}

function apply_oe_UTM(){
	const keys = ['utmsource', 'utmmedium', 'utmcampaign'];
	
	keys.forEach((key) => {
		const key_field_element = document.querySelector('.umbraco-forms-field.' + key + ' input');

		if(typeof key_field_element === 'undefined' || key_field_element === null) return;

		const key_value = sessionStorage.getItem(key);

		if(typeof key_value === 'undefined' || key_value === null || key_value === '') return;

		key_field_element.value = oe_escape(key_value);
	});
}

function clear_oe_UTM(){
	const keys = ['utmsource', 'utmmedium', 'utmcampaign'];

	keys.forEach( (key) => {
		const key_item = sessionStorage.getItem(key);

		if(typeof key_item !== 'undefined' || key_item !== null || key_item !== ''){
			sessionStorage.removeItem(key);
		}

		const key_field_element = document.querySelector('.umbraco-forms-field.' + key + ' input');

		if(typeof key_field_element === 'undefined' || key_field_element === null) return;
			
		key_field_element.value = '';
	})
}

window.addEventListener('OneTrustGroupsUpdated', event => {
    if(typeof event === 'undefined' || event === null) return;

	if(event.detail.includes('C0004')){
		init_oe_UTM();
	} else{
		clear_oe_UTM();
	}
});

window.addEventListener('load' , (event) => {
    if(typeof event === 'undefined' || event === null) return;

	if(OnetrustActiveGroups.includes('C0004')){
		init_oe_UTM();
	} else{
		clear_oe_UTM();
	}
});